<template>
  <div class="box">
    <div class="box-text">
      地址：{{apiBaseUrl}}<br/>
      日志：{{error }}<br/>
      原始日志：{{logstr}}<br/>
    </div>
    <textarea  type="text" placeholder="请输入packageStr" v-model="packageStr"></textarea>
    <button class="box-button" @click="transfer">
      确认领取
    </button>
  </div>
</template>

<script>
import Vue from 'vue'
// import qs from 'qs'
import Config from '../../config/config'
import { SDKRegister, invokeWechatTransferAsync } from '../../util/weixin'
import { Toast, Dialog } from 'vant'
Vue.use(Dialog).use(Toast)
export default {
  data() {
    return {
      error: '',
      logstr: '',
      packageStr: 'ABBQO+oYAAABAAAAAACbuYsRKWgECnw0k3eUaBAAAADnGpepZahT9IkJjn90+1qgFDayrjlCbVdP37mB1UpIDjh9pOm/lzRf9Bp6YJU0NhQlEbKHNurrnUcGbGXP8MneUBM1i0g5Dbyrz/yxOIs4TYLHoPw=',
      apiBaseUrl: Config.apiBaseUrl
    }
  },
  methods: {
    async transfer() {
      const that = this
      // const params = {}
      try {
        // 初始化 wxSDK
        const webUrl = window.location.href
        await SDKRegister(webUrl)
        // 请求发起转账参数 拿到参数 看返回状态确定是否要进行确定转账
        // that.axios
        //   .post(`/weixin/transfer`, qs.stringify(params))
        //   .thatn(result => {
        //     console.log(`result`, result);
        //   })
        //   .catch(err => {
        //     console.error('发起转账失败:', err)
        //     Toast("领取失败：", err.msg || "转账失败");
        //   });
        const packageStr = this.packageStr || '' // 这里是后台返回的转账参数
        await that.sdkRegister(packageStr)
      } catch (err) {
        // Toast.clear()
        this.error = err
        Toast('领取失败：', err.msg || '转账失败')
      }
    },
    async sdkRegister(packageStr) {
      try {
        const result = await invokeWechatTransferAsync({
          package: packageStr
        })
        console.log('转账调起成功:', result)
        this.logstr = result
        Toast('弹起成功')
      } catch (err) {
        this.logstr = err
        console.error('转账失败:', err)
        Toast('领取失败：', err.msg || '转账失败')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.box {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  &-button {
    margin-top: 16px;
    background: linear-gradient(180deg, #ffe09a 0%, #f6f8fa 100%);
    border-radius: 30px;
    color: #b4a35c;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #b4a35c;
    text-align: center;
    justify-content: center;
    align-items: center;
    outline: none;
    display: flex;
    opacity: 1;
    width: 160px;
    height: 36px;
  }
  &-text {
    margin-bottom: 20px;
  } 
  textarea{
    width: 300px;
    border: 1px solid #707070;
    min-height: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/test/index.vue